import '@/components/commit-message/commit-message.css';

export default function CommitMessage() {
  return (
    <table className='commit-message'>
      <tbody>
        <tr>
          <td>
            <b>Date:</b>
          </td>
          <td>{import.meta.env.COMMIT_DATE}</td>
        </tr>
        <tr>
          <td>
            <b>Author:</b>
          </td>
          <td>{import.meta.env.COMMIT_AUTHOR}</td>
        </tr>
        <tr>
          <td>
            <b>Commit:</b>
          </td>
          <td>{import.meta.env.COMMIT_HASH}</td>
        </tr>
        <tr>
          <td>
            <b>Message:</b>
          </td>
          <td>{import.meta.env.COMMIT_MESSAGE}</td>
        </tr>
      </tbody>
    </table>
  );
}
